<mat-sidenav-container>
	<!--Menu descriptions-->
	<mat-sidenav
		[disableClose]="true"
		mode="side"
		class="mat-elevation-z8 sidenavMenu d-flex flex-column justify-content-between"
		#sidenav
		opened
	>
		<div class="sidenav">
			<img [src]="logoProject" alt="trader-logo" class="logo"  />
			<div class="profile-image-container">
				<img [src]="logo" alt="profile-image" class="profile-image"/>
				<div class="profile-arrow">
					<mat-icon [matMenuTriggerFor]="colapseMenu" class="logout-icon">chevron_right</mat-icon>
					<mat-menu #colapseMenu="matMenu" yPosition="below">
						<button mat-menu-item class="btn-logout" (click)="logout()">Cerrar sesión</button>
					</mat-menu>
				</div>
			</div>
			<div
				class="link-menu pointer"
				[ngClass]="{'disabled': !projectSelected && !allClients}"
				*ngFor="let option of menuOptions"
				(mouseenter)="isOnHover(option)"
				(mouseleave)="inIconMenu = false; closeMenu()"
				(click)="navigate(option); eventSelected(option)"
				id="link-{{ option.moduleId }}"
			>
				<img src="assets/icons/sidenav-icons/{{ option.icon }}" />
				<span class="text-center">{{ option.moduleName }}</span>
			</div>
		</div>
		<mat-icon #menuOptionIcon class="link-menu-arrow" style="display: none"
			>play_arrow</mat-icon
		>
		<div
			class="menu-flotante"
			#menuOptionsDiv
			[ngStyle]="{'background-color': color || 'var(--color)'}"
			(mouseenter)="inSubMenu = true"
			(mouseleave)="closeSubMenu()"
		>
			<div
				class="menu-flotente-link pointer"
				*ngFor="let m of optionSelected?.modules"
				(click)="clearLocalStorage(m); eventSelected(m); navigate(m)"
			>
				{{ m.moduleName }}
			</div>
		</div>
	</mat-sidenav>

	<mat-sidenav-content class="margin-content">
		<div class="content super">
			<app-snackbar></app-snackbar>
			<app-header></app-header>
			<app-snackbar></app-snackbar>
			<router-outlet></router-outlet>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
